import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf2a1acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加商户")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = { class: "table_sle" }
const _hoisted_6 = { class: "mytooltip" }
const _hoisted_7 = { class: "el-dropdown-link" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 查看详情 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑资料")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置账号")
const _hoisted_13 = {
  key: 0,
  class: "a13box"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "Colorlabel"
}
const _hoisted_18 = {
  key: 1,
  class: "Colorlabel",
  style: {"background":"#ff687b"}
}
const _hoisted_19 = {
  key: 2,
  class: "Colorlabel",
  style: {"background":"#ffaf29"}
}
const _hoisted_20 = {
  key: 3,
  class: "Colorlabel",
  style: {"background":"#0981ff"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "openingcompany" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openingcompany_text" }, "公司名称：", -1))
const _hoisted_26 = { class: "openingcompany_text_c" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 到期时间： ")
const _hoisted_29 = {
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openingcompany_text" }, "销售对接人：", -1))
const _hoisted_31 = { class: "openingcompany_text_d" }
const _hoisted_32 = {
  key: 0,
  style: {"margin":"16px 0"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openingcompany_text" }, "购买门店数：", -1))
const _hoisted_34 = { class: "openingcompany_text_c" }
const _hoisted_35 = {
  key: 1,
  style: {"margin":"16px 0"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openingcompany_text" }, "购买门店数：", -1))
const _hoisted_37 = { class: "openingcompany_text_c" }
const _hoisted_38 = {
  key: 2,
  class: "scheme",
  style: {"margin":"16px 0"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "openingcompany_text",
  style: {"width":"72px"}
}, "购买方案：", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}, " 选择前请确认已与商户沟通确认，并已收到商户对应续费转账.计费方式为: 门店单价 ÷ 365天 x 门店数量 x 购买天数 x 折扣率 ", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 3,
  class: "scheme"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "openingcompany_text",
  style: {"width":"72px"}
}, "续费方案：", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}, "确认续费后，系统将自动给该商户生成一条续费记录", -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = {
  key: 4,
  class: "scheme",
  style: {"margin":"16px 0"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "openingcompany_text",
  style: {"width":"100px"}
}, "本次扩店数量:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}, " 至少扩充一家门店，计费方式为: 门店单价 ÷ 365天 × 新增门店 × 剩余天数（如剩余天数满足折扣条件则需乘以最新折扣比例） ", -1))
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = {
  key: 5,
  style: {"margin":"16px 0"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openingcompany_text" }, "新增门店数：", -1))
const _hoisted_52 = { class: "openingcompany_text_c" }
const _hoisted_53 = {
  key: 6,
  class: "Purchaseoptions"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "折扣价", -1))
const _hoisted_57 = { class: "hongse" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666666"} }, "/店", -1))
const _hoisted_59 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原 价", -1))
const _hoisted_61 = {
  key: 1,
  class: "rit"
}
const _hoisted_62 = { class: "Orderamount" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "one" }, "订单金额:", -1))
const _hoisted_64 = { class: "two" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" 剩余天数为 ")
const _hoisted_67 = { style: {"color":"#ff687b"} }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 天 ")
const _hoisted_69 = { key: 0 }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" ， 已享受 ")
const _hoisted_71 = { style: {"color":"#ff687b"} }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = {
  key: 1,
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}
const _hoisted_74 = {
  key: 1,
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}
const _hoisted_75 = {
  key: 2,
  class: "openingcompany_text_d",
  style: {"color":"#ff687b"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "openingcompany_text" }, "上传转账凭证：", -1))
const _hoisted_77 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_78 = { style: {"height":"20px"} }
const _hoisted_79 = { style: {"width":"500px"} }
const _hoisted_80 = { class: "dialog-footer" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("确认续费")
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Resetprompt" }, [
  /*#__PURE__*/_createTextVNode(" 将重置商户密码为: "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff687b"} }, "商户简称首拼字母+联系电话后6位,"),
  /*#__PURE__*/_createTextVNode(" 确认要重置吗？ ")
], -1))
const _hoisted_84 = { class: "dialog-footer" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_86 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_89 = { class: "Resetprompt" }
const _hoisted_90 = {
  key: 0,
  style: {"color":"#ff687b"}
}
const _hoisted_91 = {
  key: 1,
  style: {"color":"#ff687b"}
}
const _hoisted_92 = { class: "dialog-footer" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_94 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left_title" }, "公司名称：", -1))
const _hoisted_96 = { class: "right_title" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left_title" }, "纳税人识别号：", -1))
const _hoisted_98 = { class: "right_title" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left_title" }, "地址及电话：", -1))
const _hoisted_100 = { class: "right_title" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left_title" }, "开户行：", -1))
const _hoisted_102 = { class: "right_title" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left_title" }, "对 公 账 号：", -1))
const _hoisted_104 = { class: "right_title" }
const _hoisted_105 = { class: "dialog-footer" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("一键复制")

import { ElMessage } from "element-plus";
import { ArrowDown } from "@element-plus/icons-vue";
import { ref, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Plus } from "@element-plus/icons-vue";
import type { UploadProps, FormRules, FormInstance } from "element-plus";
import {
  merchantgetMerchantCentorDto,
  merchantinfo,
  merchantupdatemerchantstatus,
  merchantrestPassword,
  paymanagementgetall,
  merchantexpense,
  merchantdiffDay,
  listMerchantStoreDtos,
} from "@/api/Merchantapi";
import { toRaw } from "@vue/reactivity";
import useClipboard from "vue-clipboard3";

import moment from "moment";

//表单验证

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ruleFormRef = ref<FormInstance>();
const rulestels = ref<FormInstance>();
//vue - toClipboard 复制功能
const { toClipboard } = useClipboard();
const routers = useRouter();
const route = useRoute();
const merchantName = ref();
const userName = ref();
const userPhone = ref();
const isLoading = ref(false);
const dialogRowId = ref();
const dialogTableData = ref([]);
const dialogPage = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
const dialogTableColumn = ref([
  {
    prop: "storeName",
    label: "门店名称",
  },
  {
    prop: "createTime",
    label: "添加时间",
  },
]);
const merchantSimpleName = ref(route.query.val);
const BillingdisplayFn = async (val: any) => {
  try {
    let str = `公司名称：${merchantinfodata.value.companyName}\r\n纳税人识别号：${merchantinfodata.value.taxpayerNumber}\r\n地址及电话：${merchantinfodata.value.addressAndPhone}\r\n开户行：${merchantinfodata.value.depositBank}\r\n对公账号：${merchantinfodata.value.corporateAccount}\r\n`;
    await toClipboard(str);
    ElMessage({
      message: "复制成功!",
      type: "success",
    });
    Billingdisplay.value = false;
  } catch (e) {
    ElMessage.error("复制失败!");
  }
};
const imageUrl = ref("");
const changeImg = (val: any) => {
  console.log(val, "上传图片");
  imageUrl.value = val.fileUrl;
  isImage.value = false;
};
const headerimg = ref("/compontsimg/shicon.png");
const headercontent = ref("主要管理商户的基础资料、开票信息、开通门店数量及短信参数配置等，创建完成后商户则可登录商户管理端");
const state = reactive({
  formList: [
    // {
    //   label: "商户简称",
    //   key: "merchantSimpleName",
    //   type: "input",
    //   placeholder: "请输入商户简称查询",
    //   clearable: true,
    // },
    { slotName: "merchantSimpleName" },
    {
      label: "商户编号",
      key: "merchantSn",
      type: "input",
      placeholder: "请输入商户编号查询",
      clearable: true,
    },
    {
      label: "商户电话",
      key: "contactMobile",
      type: "input",
      placeholder: "请输入商户联系电话查询",
      clearable: true,
    },
    {
      label: "商户状态",
      key: "merchantStatus",
      type: "select",
      name: "valueName",
      clearable: true,
      optionList: [
        { labelName: "启用", value: "01" },
        { labelName: "禁用", value: "02" },
        { labelName: "到期", value: "03" },
        { labelName: "未激活", value: "04" },
      ],
      placeholder: "请选择商户状态查询",
      default: "",
    },
    {
      label: "创建时间",
      key: "datetime",
      type: "datetimerange",
      endPlaceholder: "结束时间",
      startPlaceholder: "开始时间",
      clearable: true,
    },
  ],
});
const formInline = reactive<{ storename: string }>({ storename: "" });
const ruleForm = reactive({ gooleId: "" });
const rules = reactive<FormRules>({
  gooleId: [{ required: true, message: "请输入谷歌验证码", trigger: "blur" }],
});
const changeSelect = () => {
  console.log(state);
};
const params = ref<Req.merchantgetMerchantCentorDto>({
  contactMobile: "",
  endTime: "",
  merchantSimpleName: "",
  merchantSn: "",
  merchantStatus: "",
  pageNum: 1,
  pageSize: 10,
  startTime: "",
});

const tableData = ref([]);
const MyTablelist = ref<any>({
  total: 10,
  pageSize: 10,
  currentPage: 1,
});
const submitForm = (val: any) => {
  console.log(val.value);

  let par = ref<any>({
    contactMobile: val.value.contactMobile,
    endTime: params.value.endTime || "",
    merchantSimpleName: merchantSimpleName.value,
    merchantSn: val.value.merchantSn,
    merchantStatus: val.value.merchantStatus,
    pageNum: params.value.pageNum || 1,
    pageSize: params.value.pageSize || 10,
    startTime: params.value.startTime || "",
  });
  if (val.value.datetime && val.value.datetime.length) {
    let list = toRaw(val.value.datetime);
    let endTimes = new Date(list[1]).valueOf() + 24 * 60 * 60 * 1000 - 1;
    let startTimes = new Date(list[0]).valueOf();
    par.value.endTime = endTimes;
    par.value.startTime = startTimes;
  } else {
    par.value.endTime = "";
    par.value.startTime = "";
  }
  params.value = par.value;
  merchantgetMerchantCentorDto(par.value).then((res) => {
    console.log(res, "列表");

    tableData.value = res.data.list;
    tableData.value.forEach((item: any) => {
      item.createTime = item.createTime ? timestampToTime(item.createTime) : "--";
      item.abortTime = item.abortTime ? timestampToTime(item.abortTime) : "--";
    });
    MyTablelist.value = {
      total: res.data.total,
      pageSize: res.data.pageSize,
      currentPage: res.data.pageNum,
    };
    //  item.updateTime = new Date(parseInt(item.updateTime) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ')
  });
};

// 初始化表格 - created 请求 表格data
submitForm(params);
const handleCurrentChange = (val: number) => {
  console.log(val, "页码");

  params.value.pageNum = val || 1;
  params.value.pageSize = MyTablelist.value.pageSize;
  console.log(params.value, "----------------------");

  submitForm(params);
};
const handleSizeChange = (val: number) => {
  console.log(val, "页数");
  params.value.pageSize = val || 10;
  submitForm(params);
};

const dialogVisible = ref(false);
const Disabledisplay = ref(false);
const DisabledtitleL = ref("禁用账号");
const DisabledtitleR = ref("");
const EnabledisableId = ref();
const resetpasswordId = ref();
const handleCommand = (command: string | number | any) => {
  // ElMessage(`click on item ${command}`);
  if (command.command == "b") {
    //重置密码
    resetpasswordId.value = command.row.id;
    chongzhiTest.value = command.row.merchantSimpleName;
    dialogVisible.value = true;
  } else if (command.command == "c") {
    // 禁用账号
    if (command.row.merchantStatus == "01") {
      DisabledtitleL.value = "禁用账号";
    } else {
      DisabledtitleL.value = "启用账号";
    }
    EnabledisableId.value = command.row.id;
    DisabledtitleR.value = command.row.merchantSimpleName;
    Disabledisplay.value = true;
  } else if (command.command == "a") {
    console.log(command.row, "行内数据");
    toAddmerchant(command.row);
  }
};

// 启用禁用
const EnabledisableFn = () => {
  merchantupdatemerchantstatus({
    merchantId: EnabledisableId.value,
    merchantStatus: DisabledtitleL.value == "禁用账号" ? "02" : "01",
  })
    .then((res) => {
      if (res.code == 1) {
        ElMessage({
          message: "操作成功！",
          type: "success",
        });
        submitForm(params);
        Disabledisplay.value = false;
      }
    })
    .catch((err) => {
      ElMessage.error("操作失败!");
    });
};

// 重置密码
const resetpassword = async (formEl: FormInstance | undefined, pwdid: string) => {
  console.log(pwdid);
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      merchantrestPassword({ merchantId: resetpasswordId.value, command: pwdid })
        .then((res) => {
          console.log(res, "重置密码");
          if (res.code == 1) {
            ElMessage({
              message: "操作成功！",
              type: "success",
            });
            dialogVisible.value = false;
          }
        })
        .catch((err) => {
          ElMessage.error("操作失败!");
        });
    } else {
      console.log("error submit!", fields);
    }
  });
};

// 时间戳
const timestampToTime = (timestamp: any) => {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  let D = date.getDate() + " ";
  let h = date.getHours() + ":";
  let m = date.getMinutes() + ":";
  let s = date.getSeconds();
  return Y + M + D + h + m + s;
};
// 开户
const BASE_STORE_NUM = ref<any>({});
const BASE_STORE_PRICE = ref<any>({});
const DISCOUNT_PRICE_6 = ref<any>({});
const DISCOUNT_PRICE_12 = ref<any>({});
const DISCOUNT_PRICE_24 = ref<any>({});
const DISCOUNT_PRICE_36 = ref<any>({});
const EXPIRE_REMIND = ref<any>({});
const openId = ref();
const opentype = ref("01"); //01:开户 02:续费 03:扩店
const openstore = (row: any) => {
  imageUrl.value = "";
  openShow.value = true;
  merchantName.value = row.merchantName;
  userPhone.value = row.userPhone;
  userName.value = row.userName;
  opentype.value = "01";
  MyTitle.value = "开户购店";
  openId.value = row.id;
};
//商户编辑 -- 跳转 - 回显
const toAddmerchant = (row: any) => {
  // const data = JSON.stringify(row);
  routers.push({ path: "/Merchantmanagement/Newmerchants", query: { id: row.id } });
};
//添加商户 -- 跳转
const toAddmerchantbtn = () => {
  routers.push({ path: "/Merchantmanagement/Newmerchants" });
};
//续费/扩店表单数据对话框显示变量
const openShow = ref(false);
const boughtStoreNumtt = ref(1);
const abortTimett = ref();
const sydays = ref();
const discount = ref();

//续费/扩店表单门店数
const num = ref(1);
//购买方案初始数据
const purchaselist = ref<any[]>([
  { zp: "700", yp: "800", zk: 92, yue: 6, check: true },
  { zp: "1000", yp: "1200", zk: 95, yue: 12, check: false },
  { zp: "500", yp: "800", zk: 97, yue: 24, check: false },
  { zp: "100", yp: "1000", zk: 10, yue: 36, check: false },
]);

const ruleKey = ref();
const MyTitle = ref();
// 开户信息
const ffn = () => {
  paymanagementgetall().then((res) => {
    console.log(res, "开户信息");

    BASE_STORE_NUM.value = res.data[0];
    BASE_STORE_PRICE.value = res.data[1];
    DISCOUNT_PRICE_6.value = res.data[2];
    DISCOUNT_PRICE_12.value = res.data[3];
    DISCOUNT_PRICE_24.value = res.data[4];
    DISCOUNT_PRICE_36.value = res.data[5];
    EXPIRE_REMIND.value = res.data[6];
    let arr = [DISCOUNT_PRICE_6.value, DISCOUNT_PRICE_12.value, DISCOUNT_PRICE_24.value, DISCOUNT_PRICE_36.value];
    arr.forEach((jitm, jindex) => {
      purchaselist.value.forEach((item, index) => {
        if (index == jindex) {
          item.yp = BASE_STORE_PRICE.value.ruleValue * jitm.multiplyValue;
          item.yue = jitm.parallelismMonth;
          item.ruleKey = jitm.ruleKey;
          item.configEnable = jitm.configEnable;

          item.zk = item.configEnable ? jitm.ruleValue : 10;
          // 如果为true为折扣价格，不是则为原价
          item.zp = item.configEnable
            ? jitm.multiplyValue * (jitm.ruleValue / 10) * BASE_STORE_PRICE.value.ruleValue
            : jitm.multiplyValue * BASE_STORE_PRICE.value.ruleValue;
        }
      });
    });
    console.log(purchaselist.value, "*******************");

    ruleKey.value = DISCOUNT_PRICE_6.value.ruleKey;
    num.value = BASE_STORE_NUM.value.ruleValue;
    handleChange(num.value);
  });
};
ffn(); //执行初始化数据信息方法
const form = ref<any>({ payerName: "", payerPhone: "", command: "" }); //续费/扩店表单数据

//续费/扩店表单手机号正则验证
const storeNumRules = (rule: any, value: any, callback: any) => {
  if (!value) {
    return callback(new Error("请输入付款人联系电话"));
  }
  setTimeout(() => {
    var reg = /^1[3-9]\d{9}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入正确的手机号码"));
    }
  }, 500);
};
const merdata = ref(); //开户数据
const isImage = ref(false);
//续费/扩店表单节点验证
const Confirmrenewal = () => {
  if (!form.value.payerName || !form.value.payerPhone || !form.value.command || !imageUrl.value) {
    ElMessage.warning("请补全信息");
    isImage.value = true;
    return;
  } else {
    isImage.value = false;
  }

  merdata.value = {
    boughtStoreNum: boughtStoreNumtt.value,
    command: form.value.command,
    merchantId: openId.value,
    orderPrice: Math.floor(Totalprice.value),
    payerName: form.value.payerName,
    payerPhone: form.value.payerPhone,
    ruleKey: ruleKey.value,
    storeNum: num.value,
    transferCredentials: imageUrl.value,
    type: opentype.value,
  };
  console.log(merdata.value, "----------------------------");

  merchantexpense(merdata.value)
    .then((res) => {
      console.log(res, "买店");
      if (res.code == 1) {
        ElMessage({
          message: "操作成功！",
          type: "success",
        });
        submitForm(params);
        openShow.value = false;
      }
    })
    .catch((err) => {
      // ElMessage.error("操作失败！");
    });
};

const rulestel = reactive<FormRules>({
  payerName: [{ required: true, message: "请输入付款人姓名", trigger: "blur" }],
  payerPhone: [{ required: true, validator: storeNumRules, trigger: "blur" }],
  command: [{ required: true, message: "请输入谷歌验证码", trigger: "blur" }],
});
const Totalprice = ref<any>();

// 折扣框
const programmeFn = (item: Res.aaa) => {
  console.log(item.yue);
  console.log(item.zp);
  console.log(item);

  purchaselist.value.forEach((res) => {
    if (res.yue == item.yue) {
      res.check = true;
      ruleKey.value = res.ruleKey;
    } else {
      res.check = false;
    }
  });
  Totalprice.value = Math.floor(num.value * Number(item.zp));
};

const handleChange = (val: number) => {
  if (opentype.value != "03") {
    console.log(val);
    purchaselist.value.forEach((res) => {
      if (res.check) {
        Totalprice.value = Math.floor(num.value * Number(res.zp));
      }
    });
  } else {
    let nnn = Math.floor((BASE_STORE_PRICE.value.ruleValue / 365) * 100) / 100;
    let yj = DISCOUNT_PRICE_6.value.configEnable;
    Totalprice.value = Math.floor(nnn * num.value * sydays.value * 0.1 * (yj ? discount.value : 10));
  }
};

const Billingdisplay = ref(false);
const merchantinfodata = ref<any>([]);
const BillingFn = (row: any) => {
  let params = { merchantId: row.id };
  merchantinfo(params).then((res) => {
    console.log(res, "商户详情");
    merchantinfodata.value = res.data;
    console.log(merchantinfodata.value.companyName);
  });
  Billingdisplay.value = true;
};

const storedisplay = ref(false);
const viewstore = (row: any) => {
  storedisplay.value = true;
  dialogRowId.value = row.id;
  dialogHandleCurrentChange(1);
};
const delectImg = (val: string) => {
  imageUrl.value = val;
};
//续费按钮 -- 扩店按钮
const openstop = (row: any) => {
  openShow.value = true;
  merchantName.value = row.merchantName;
  userPhone.value = row.userPhone;
  userName.value = row.userName;
  opentype.value = "03";
  openId.value = row.id;
  num.value = 1;
  MyTitle.value = "扩店补费";
  boughtStoreNumtt.value = row.boughtStoreNum;
  abortTimett.value = timestampToTime(row.abortTime);
  let timestamp = new Date().getTime();
  merchantdiffDay({ nowTime: moment(row.abortTime).valueOf(), endTime: timestamp }).then((res) => {
    console.log(res, "剩余天数");
    sydays.value = res.data.diffDay;
    if (sydays.value >= 180 && sydays.value <= 359) {
      discount.value = DISCOUNT_PRICE_6.value.ruleValue;
    } else if (sydays.value > 360 && sydays.value < 719) {
      discount.value = DISCOUNT_PRICE_12.value.ruleValue;
    } else if (sydays.value > 720 && sydays.value < 1079) {
      discount.value = DISCOUNT_PRICE_24.value.ruleValue;
    } else if (sydays.value > 1080 && sydays.value < 10000) {
      discount.value = DISCOUNT_PRICE_36.value.ruleValue;
    } else {
      discount.value = 10;
    }
    let nnn = Math.floor((BASE_STORE_PRICE.value.ruleValue / 365) * 100) / 100;
    console.log(nnn, "-------------_+++++++++++++++++++");
    let yj = DISCOUNT_PRICE_6.value.configEnable;
    Totalprice.value = Math.floor(nnn * num.value * sydays.value * 0.1 * (yj ? discount.value : 10));
    console.log(Totalprice.value, "-----------+++");
  });
};
const openstopxF = (row: any) => {
  openShow.value = true;
  merchantName.value = row.merchantName;
  userPhone.value = row.userPhone;
  userName.value = row.userName;
  opentype.value = "02";
  boughtStoreNumtt.value = row.boughtStoreNum;
  num.value = boughtStoreNumtt.value;
  console.log(boughtStoreNumtt.value);
  console.log(num.value);

  abortTimett.value = timestampToTime(row.abortTime);
  openId.value = row.id;
  let timestamp = new Date().getTime();
  console.log(DISCOUNT_PRICE_6.value.ruleValue, "99999999");

  Totalprice.value = Math.floor(num.value * 0.1 * BASE_STORE_PRICE.value.ruleValue * DISCOUNT_PRICE_6.value.multiplyValue * purchaselist.value[0].zk);
  MyTitle.value = "门店续费";
};
const tableColumn = ref([
  {
    slotName: "id",
  },
  {
    prop: "merchantName",
    label: "商户全称",
  },
  {
    prop: "merchantSimpleName",
    label: "商户简称",
  },
  {
    slotName: "address",
  },
  {
    prop: "contactName",
    label: "联系人姓名",
  },
  {
    prop: "contactMobile",
    label: "联系人电话",
  },
  {
    prop: "storeNum",
    label: "登记门店",
  },
  { slotName: "dredgeStoreNum" },
  { slotName: "a7" },
  {
    prop: "merchantAccount",
    label: "登录账号",
  },
  {
    prop: "userName",
    label: "销售对接人",
  },
  {
    prop: "createTime",
    label: "创建时间",
  },
  // {
  //   prop: "a13",
  //   label: "使用截止期限",
  // },
  {
    slotName: "abortTime",
  },
  {
    slotName: "slotName",
  },
]);
const openShowClose = () => {
  form.value = { payerName: "", payerPhone: "", command: "" };
  imageUrl.value = "";
};
const dialogHandleCurrentChange = (val: any) => {
  if (val) {
    dialogPage.value.pageNum = val;
  }
  const baseRequest = {
    storeName: formInline.storename || "",
    merchantSn: dialogRowId.value,
    pageNum: dialogPage.value.pageNum,
    pageSize: dialogPage.value.pageSize,
  };
  isLoading.value = true;
  listMerchantStoreDtos(baseRequest).then((res) => {
    if (res.code === 1) {
      res.data.list.forEach((item: any) => {
        item.createTime = moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
      });
      dialogTableData.value = res.data.list;
      dialogPage.value.total = res.data.total;
      dialogPage.value.pageNum = res.data.pageNum;
      isLoading.value = false;
    }
  });
};
const chongzhiTest = ref("");
const dialogHandleSizeChange = (val: any) => {
  dialogPage.value.pageSize = val;
  dialogHandleCurrentChange(1);
};
const storedisplayClose = () => {
  formInline.storename = "";
};

return (_ctx: any,_cache: any) => {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Publicform = _resolveComponent("Publicform")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_MyUpload = _resolveComponent("MyUpload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "商户列表",
      img: headerimg.value,
      text: headercontent.value
    }, null, 8, ["img", "text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Publicform, {
          formList: state.formList,
          ref: "addAndEditDom",
          onChangeSelect: changeSelect,
          onSubmitForm: submitForm
        }, {
          merchantSimpleName: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商户简称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: merchantSimpleName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((merchantSimpleName).value = $event)),
                  class: "myinput",
                  placeholder: "请输入商户简称查询",
                  clearable: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          from: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              class: "addbutton",
              onClick: toAddmerchantbtn,
              icon: _unref(Plus)
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["formList"]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MyTable, {
            tableData: tableData.value,
            ifselection: false,
            isPagination: true,
            isHeight: false,
            isIndex: true,
            tableColumn: tableColumn.value,
            onHandleCurrentChange: handleCurrentChange,
            onHandleSizeChange: handleSizeChange,
            total: MyTablelist.value.total,
            pageSize: MyTablelist.value.pageSize,
            currentPage: MyTablelist.value.currentPage
          }, {
            address: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "商户地址",
                width: "150",
                align: "left"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_tooltip, {
                    content: row.address,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(row.address), 1)
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]),
                _: 1
              })
            ]),
            slotName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_dropdown, {
                    onCommand: handleCommand,
                    trigger: "click",
                    onVisibleChange: 
                  (val) => {
                    row.select = val;
                  }
                
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            command: { row: row, command: 'a' }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["command"]),
                          _createVNode(_component_el_dropdown_item, {
                            command: { row: row, command: 'b' }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["command"]),
                          _createVNode(_component_el_dropdown_item, {
                            command: { row: row, command: 'c' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.merchantStatus == "01" ? "禁用账号" : "启用账号"), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, [
                        _hoisted_8,
                        (_openBlock(), _createElementBlock("svg", {
                          viewBox: "0 0 1024 1024",
                          style: {"transition":"all 0.1s linear"},
                          class: _normalizeClass({ isActive: row.select }),
                          width: "14px",
                          xmlns: "http://www.w3.org/2000/svg",
                          "data-v-78e17ca8": ""
                        }, _hoisted_10, 2))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onVisibleChange"])
                ]),
                _: 1
              })
            ]),
            abortTime: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "使用截止期限",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.abortTime || "--"), 1),
                  (row.merchantStatus == '01' || row.merchantStatus == '03')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("span", {
                          class: "bluetxt",
                          onClick: ($event: any) => (openstopxF(row))
                        }, "续费", 8, _hoisted_14),
                        _createElementVNode("span", {
                          class: "yellowtxt",
                          onClick: ($event: any) => (openstop(row))
                        }, "扩店", 8, _hoisted_15)
                      ]))
                    : _createCommentVNode("", true),
                  (row.merchantStatus == '04')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "bluetxt",
                        onClick: ($event: any) => (openstore(row))
                      }, "开户购店", 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            id: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "商户编号",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.merchantStatus == '01')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "正常"))
                    : _createCommentVNode("", true),
                  (row.merchantStatus == '02')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "禁用"))
                    : _createCommentVNode("", true),
                  (row.merchantStatus == '03')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "到期"))
                    : _createCommentVNode("", true),
                  (row.merchantStatus == '04')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "未激活"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(row.id), 1)
                ]),
                _: 1
              })
            ]),
            dredgeStoreNum: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "开通门店数量",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(row.dredgeStoreNum || 0), 1),
                  (row.dredgeStoreNum)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "bluetxt",
                        onClick: ($event: any) => (viewstore(row))
                      }, "查看门店", 8, _hoisted_21))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            a7: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "开票信息",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(row.a7), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "bluetxt",
                    onClick: ($event: any) => (BillingFn(row))
                  }, "查看", 8, _hoisted_23)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["tableData", "tableColumn", "total", "pageSize", "currentPage"])
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: openShow.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((openShow).value = $event)),
          title: MyTitle.value,
          width: "660px",
          onClose: openShowClose
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_80, [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (openShow.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_81
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: Confirmrenewal
              }, {
                default: _withCtx(() => [
                  _hoisted_82
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                _hoisted_25,
                _createElementVNode("span", _hoisted_26, _toDisplayString(merchantName.value), 1)
              ]),
              (opentype.value != '01')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("span", _hoisted_29, _toDisplayString(abortTimett.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _hoisted_30,
                _createElementVNode("span", _hoisted_31, _toDisplayString(userName.value) + "-" + _toDisplayString(userPhone.value), 1)
              ])
            ]),
            (opentype.value == '01')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_el_input_number, {
                    modelValue: num.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((num).value = $event)),
                    min: BASE_STORE_NUM.value.ruleValue,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "min"]),
                  _createElementVNode("span", _hoisted_34, "（" + _toDisplayString(BASE_STORE_PRICE.value.ruleValue) + "元/店/年，最低起购门店数为: " + _toDisplayString(BASE_STORE_NUM.value.ruleValue) + "家）", 1)
                ]))
              : _createCommentVNode("", true),
            (opentype.value != '01')
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", _hoisted_37, _toDisplayString(boughtStoreNumtt.value) + "家", 1)
                ]))
              : _createCommentVNode("", true),
            (opentype.value == '01')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41))
              : _createCommentVNode("", true),
            (opentype.value == '02')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45))
              : _createCommentVNode("", true),
            (opentype.value == '03')
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_49))
              : _createCommentVNode("", true),
            (opentype.value == '03')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _hoisted_51,
                  _createVNode(_component_el_input_number, {
                    modelValue: num.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((num).value = $event)),
                    min: 1,
                    onChange: handleChange
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_52, "（" + _toDisplayString(Math.floor(BASE_STORE_PRICE.value.ruleValue)) + "元/店/年）", 1)
                ]))
              : _createCommentVNode("", true),
            (opentype.value != '03')
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchaselist.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass([item.check ? 'sixml s_border' : 'sixml']),
                      onClick: ($event: any) => (programmeFn(item))
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.yue) + "个月", 1),
                      (item.configEnable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("span", _hoisted_57, [
                              _createTextVNode(" ￥" + _toDisplayString(item.zp.toFixed(2)) + " ", 1),
                              _hoisted_58
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("span", {
                          class: "xaihuaxian",
                          style: _normalizeStyle(item.configEnable ? 'text-decoration: line-through;' : '')
                        }, "￥" + _toDisplayString(item.yp) + "/店", 5)
                      ]),
                      (item.configEnable)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(item.zk) + "折", 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_54))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", null, [
                _hoisted_63,
                _createElementVNode("span", _hoisted_64, "￥" + _toDisplayString(Math.floor(Totalprice.value)), 1)
              ]),
              (opentype.value == '03')
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("span", _hoisted_67, _toDisplayString(sydays.value), 1),
                    _hoisted_68,
                    (DISCOUNT_PRICE_6.value.configEnable)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (discount.value != 10)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("span", _hoisted_71, _toDisplayString(discount.value), 1),
                                _createTextVNode(" 折优惠 （原价：￥" + _toDisplayString(Math.floor((Math.floor((BASE_STORE_PRICE.value.ruleValue / 365) * 100) / 100) * num.value * sydays.value)) + "） ", 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_72, "（原价：￥" + _toDisplayString(Math.floor((Math.floor((BASE_STORE_PRICE.value.ruleValue / 365) * 100) / 100) * num.value * sydays.value)) + "）", 1))
                        ], 64))
                      : _createCommentVNode("", true),
                    (opentype.value == '03')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, "确认续费后，系统将自动给该商户生成一条充值记录"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (opentype.value == '01')
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, "确认购买后，系统将自动给该商户生成一条首购记录"))
                : _createCommentVNode("", true),
              (opentype.value == '02')
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, "确认续费后，系统将自动给该商户生成一条续费记录"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", null, [
                _createVNode(_component_MyUpload, {
                  modelValue: imageUrl.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((imageUrl).value = $event)),
                  imageUrl: imageUrl.value,
                  tipText: "",
                  onChangeImg: changeImg,
                  onDelectImg: delectImg
                }, null, 8, ["modelValue", "imageUrl"]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ ImageLoad: isImage.value }),
                    style: {"font-size":"12px","color":"#f56c6c","position":"relative","height":"0px","transition":"all 0.3s linear","display":"block","overflow":"hidden"}
                  }, " 请上传转账凭证 ", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_el_form, {
                  model: form.value,
                  "label-width": "120px",
                  rules: rulestel,
                  ref_key: "rulestels",
                  ref: rulestels
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "付款人姓名",
                      prop: "payerName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.payerName,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.payerName) = $event)),
                          maxlength: "20",
                          placeholder: "请输入付款人姓名（20字符内）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "联系电话",
                      prop: "payerPhone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.payerPhone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.payerPhone) = $event)),
                          maxlength: "11",
                          placeholder: "请输入联系电话（11位手机号）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "谷歌动态码",
                      prop: "command"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.command,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.command) = $event)),
                          placeholder: "请输入谷歌动态码"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible).value = $event)),
          title: '重置密码-' + chongzhiTest.value,
          width: "550px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_84, [
              _createVNode(_component_el_button, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (dialogVisible.value = false)),
                class: "cancelBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_85
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (resetpassword(ruleFormRef.value, ruleForm.gooleId)))
              }, {
                default: _withCtx(() => [
                  _hoisted_86
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_83,
            _createVNode(_component_el_form, {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              "label-position": "right",
              "label-width": "120px",
              model: ruleForm,
              rules: rules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "谷歌验证码",
                  prop: "gooleId",
                  "label-width": "94px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: ruleForm.gooleId,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ruleForm.gooleId) = $event)),
                      placeholder: "请输入谷歌动态口令"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(_component_el_dialog, {
          modelValue: storedisplay.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((storedisplay).value = $event)),
          title: "查看已添加门店",
          width: "980px",
          onClose: storedisplayClose
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              inline: true,
              model: formInline,
              class: "demo-form-inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"200px"},
                      modelValue: formInline.storename,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formInline.storename) = $event)),
                      clearable: "",
                      placeholder: "请输入门店名称查询"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (dialogHandleCurrentChange(1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_87
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_MyTable, {
              isLoading: isLoading.value,
              tableData: dialogTableData.value,
              ifselection: false,
              isHeight: false,
              isPagination: true,
              isIndex: true,
              tableColumn: dialogTableColumn.value,
              onHandleCurrentChange: dialogHandleCurrentChange,
              onHandleSizeChange: dialogHandleSizeChange,
              currentPage: dialogPage.value.pageNum,
              pageSize: dialogPage.value.pageSize,
              total: dialogPage.value.total
            }, null, 8, ["isLoading", "tableData", "tableColumn", "currentPage", "pageSize", "total"]),
            _hoisted_88
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: Disabledisplay.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((Disabledisplay).value = $event)),
          title: DisabledtitleL.value + '  -  ' + DisabledtitleR.value,
          width: "380px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_92, [
              _createVNode(_component_el_button, {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (Disabledisplay.value = false)),
                class: "cancelBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_93
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: EnabledisableFn
              }, {
                default: _withCtx(() => [
                  _hoisted_94
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_89, [
              (DisabledtitleL.value == '禁用账号')
                ? (_openBlock(), _createElementBlock("span", _hoisted_90, "禁用账号，该商户将无法进行访问及 操作，确认要继续吗？"))
                : (_openBlock(), _createElementBlock("span", _hoisted_91, "启用账号，该商户将恢复访问及操作，确认要继续吗？"))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(_component_el_dialog, {
          modelValue: Billingdisplay.value,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((Billingdisplay).value = $event)),
          title: "查看开票信息",
          width: "434px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_105, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (BillingdisplayFn(merchantinfodata.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_106
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_95,
              _createElementVNode("span", _hoisted_96, _toDisplayString(merchantinfodata.value.companyName || "--"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_97,
              _createElementVNode("span", _hoisted_98, _toDisplayString(merchantinfodata.value.taxpayerNumber || "--"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_99,
              _createElementVNode("span", _hoisted_100, _toDisplayString(merchantinfodata.value.addressAndPhone || "--"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_101,
              _createElementVNode("span", _hoisted_102, _toDisplayString(merchantinfodata.value.depositBank || "--"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_103,
              _createElementVNode("span", _hoisted_104, _toDisplayString(merchantinfodata.value.corporateAccount || "--"), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ], 64))
}
}

})